import React from "react"
import PropTypes from "prop-types"
import Alert from "react-bootstrap/Alert"
import Button from "react-bootstrap/Button"
import { useIntl } from "react-intl"

/**
 * ErrorMessage component
 * 
 * Displays an error message with an optional retry button.
 * Used for showing API errors and other failure states.
 */
const ErrorMessage = ({ error, onRetry }) => {
  const intl = useIntl()

  return (
    <Alert variant="danger">
      <Alert.Heading>
        <i className="fas fa-exclamation-triangle me-2" aria-hidden="true"></i>
        {intl.formatMessage({ id: "Error" })}
      </Alert.Heading>
      <p>{error}</p>
      {onRetry && (
        <div className="d-flex justify-content-end">
          <Button onClick={onRetry} variant="outline-danger" size="sm">
            <i className="fas fa-redo me-1" aria-hidden="true"></i>
            {intl.formatMessage({ id: "Retry" })}
          </Button>
        </div>
      )}
    </Alert>
  )
}

ErrorMessage.propTypes = {
  error: PropTypes.string.isRequired,
  onRetry: PropTypes.func,
}

export default ErrorMessage
